"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appProvisioningResponseSchema = exports.appProvisioningRequestSchema = exports.appProvisioningOperationSchema = exports.APP_PROVISIONING_PROTOCOL_VERSION = void 0;
const zod_1 = require("zod");
const events_1 = require("./events");
const permissions_1 = require("./permissions");
exports.APP_PROVISIONING_PROTOCOL_VERSION = "1.0";
exports.appProvisioningOperationSchema = zod_1.z.enum([
    "INSTALL",
    "UPDATE",
    "UNINSTALL",
]);
exports.appProvisioningRequestSchema = zod_1.z
    .object({
    protocolVersion: zod_1.z.literal(exports.APP_PROVISIONING_PROTOCOL_VERSION),
    operation: exports.appProvisioningOperationSchema,
    idempotencyKey: zod_1.z.string().trim().min(16).max(240),
    installation: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        tenantId: zod_1.z.string().uuid(),
        businessId: zod_1.z.string().uuid(),
        appId: zod_1.z.string().trim().min(3).max(80),
        appVersion: zod_1.z.string().trim().min(1).max(40),
        provisioningRevision: zod_1.z.number().int().positive(),
    }),
    permissions: zod_1.z.array(permissions_1.appPermissionSchema),
    subscriptions: zod_1.z.array(events_1.builtInIntegrationEventTypeSchema),
    eventDeliveryEndpointUrl: zod_1.z.string().url().optional(),
    credential: zod_1.z
        .object({
        kind: zod_1.z.literal("SIGNING_SECRET"),
        value: zod_1.z.string().min(32).max(500),
        fingerprint: zod_1.z.string().trim().min(8).max(128),
    })
        .optional(),
    dataRetention: zod_1.z.object({
        appOwnedData: zod_1.z.enum(["RETAIN", "DELETE", "ANONYMIZE"]),
        appOwnedDataRetentionDays: zod_1.z.number().int().min(0).max(3_650).optional(),
    }),
})
    .superRefine((request, context) => {
    if (request.operation === "UNINSTALL" && request.credential) {
        context.addIssue({
            code: "custom",
            message: "Uninstall callbacks cannot receive active credentials.",
            path: ["credential"],
        });
    }
    if (request.operation !== "UNINSTALL" &&
        request.subscriptions.length > 0 &&
        (!request.credential || !request.eventDeliveryEndpointUrl)) {
        context.addIssue({
            code: "custom",
            message: "Event-consuming installations require an endpoint and signing credential.",
            path: ["subscriptions"],
        });
    }
});
exports.appProvisioningResponseSchema = zod_1.z.object({
    protocolVersion: zod_1.z.literal(exports.APP_PROVISIONING_PROTOCOL_VERSION),
    installationId: zod_1.z.string().uuid(),
    status: zod_1.z.literal("READY"),
});
//# sourceMappingURL=provisioning.js.map